export default __webpack_public_path__ + "static/media/ic_sint_eustatius.4a90202f.svg";